import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography
} from '@material-ui/core';
import axios from 'axios';
import Cookies from 'js-cookie';
import React, { useState } from 'react';
import { CioIdentify } from '../domainTypes/customerio';
import ENV from '../env.json';

export const AiVisibilityAccessDialog = ({
  open,
  onClose
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const [email, setEmail] = useState('');
  const [websiteUrl, setWebsiteUrl] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const onHandleSubmit = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    if (!email) {
      setError('Please enter your business email address.');
      return;
    }
    if (email.includes('gmail') || email.includes('hotmail')) {
      setError(
        'Please use your business email address. We do not accept free or single-use email addresses.'
      );
      return;
    }
    if (!websiteUrl) {
      setError('Please enter the website you want to run campaigns on.');
      return;
    }
    setError(null);
    setIsSubmitting(true);

    const user: CioIdentify = {
      email,
      id: email,
      lists: ['ai_visibility_waitlist'],
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      source: window.location.pathname,
      referrer: document.referrer || '',
      waitlist_url: websiteUrl,
      cookies: JSON.stringify(Cookies.get())
    };

    try {
      await axios.post(`${ENV.cloudFunctionsDomain}/mail-createLeadV2`, user);
      setSubmitted(true);
    } catch (_) {
      setError('Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <strong>Request early access to AI visibility campaigns</strong>
      </DialogTitle>
      <form onSubmit={onHandleSubmit}>
        <DialogContent>
          {submitted ? (
            <>
              <Typography variant="body1" component="p" paragraph>
                <strong>Thanks! You&apos;re on the list!</strong>
              </Typography>
              <Typography variant="body2" component="p" paragraph>
                We're onboarding publishers to AI visibility campaigns in small
                groups. Our team will reach out when it's your turn.
              </Typography>
            </>
          ) : (
            <>
              <Typography variant="body2" component="p" paragraph>
                AI visibility campaigns are coming soon. Tell us where to reach
                you and which site you want to monetize, and we'll be in touch
                as spots open up.
              </Typography>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                type="email"
                label="Your business email"
                placeholder="yourname@yourwebsite.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                name="email"
                autoComplete="email"
                autoFocus
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                type="url"
                label="Your website"
                placeholder="https://"
                value={websiteUrl}
                onChange={(e) => setWebsiteUrl(e.target.value)}
                name="websiteUrl"
                autoComplete="url"
              />
              {error && (
                <Typography
                  variant="caption"
                  component="p"
                  color="error"
                  style={{ marginTop: '8px' }}
                >
                  {error}
                </Typography>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions style={{ padding: '16px 24px 24px' }}>
          {submitted ? (
            <Button variant="contained" color="primary" onClick={onClose}>
              Done
            </Button>
          ) : (
            <>
              <Button variant="text" onClick={onClose}>
                Cancel
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={isSubmitting}
              >
                Request early access
              </Button>
            </>
          )}
        </DialogActions>
      </form>
    </Dialog>
  );
};
